import React from "react";
import {
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  getPaginationRowModel,
  Header,
  useReactTable,
  Table,
} from "@tanstack/react-table";
import {
  Grid,
  Group,
  Pagination as ManPagination,
  Paper,
  Select,
  Text,
} from "@mantine/core";
export interface IPaginationProps {
  table: Table<unknown>;
  totalCount: number;
}

export const Pagination: React.FC<IPaginationProps> = ({
  table,
  totalCount,
}) => {
  const pageIndex = table.getState().pagination.pageIndex;
  const pageSize = table.getState().pagination.pageSize;
  const pageLength = table.getPaginationRowModel().rows.length;
  return (
    <Paper p="md" withBorder sx={{ borderTop: 0 }} radius={0}>
      <Grid>
        <Grid.Col span={10}>
          <Group sx={{ flexGrow: 1 }} spacing="md">
            <ManPagination
              page={pageIndex + 1}
              total={table.getPageCount()}
              size="sm"
              withEdges
              radius="xs"
              onChange={(currentPage) => {
                table.setPageIndex(currentPage - 1);
              }}
            />
            <Group spacing="xs">
              <Select
                data={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "20", label: "20" },
                  { value: "100", label: "100" },
                ]}
                size="xs"
                radius={0}
                sx={{width:70}}
                defaultValue={table.getState().pagination.pageSize.toString()}
                onChange={(item) => {
                  table.setPageSize(Number(item));
                }}
              />
              <Text fz="sm">
              items per page
              </Text>
            </Group>
          </Group>
        </Grid.Col>
        <Grid.Col span={2}>
          <Text fz="sm" sx={{ textAlign: "end" }}>
            Showing {pageIndex * pageSize + 1} -{" "}
            {pageIndex * pageSize + pageLength} of {totalCount}
          </Text>
        </Grid.Col>
      </Grid>
      {/* <button
        className="border rounded p-1"
        onClick={() => table.setPageIndex(0)}
        disabled={!table.getCanPreviousPage()}
      >
        {"<<"}
      </button>
      <button
        className="border rounded p-1"
        onClick={() => table.previousPage()}
        disabled={!table.getCanPreviousPage()}
      >
        {"<"}
      </button>
      <button
        className="border rounded p-1"
        onClick={() => table.nextPage()}
        disabled={!table.getCanNextPage()}
      >
        {">"}
      </button>
      <button
        className="border rounded p-1"
        onClick={() => table.setPageIndex(table.getPageCount() - 1)}
        disabled={!table.getCanNextPage()}
      >
        {">>"}
      </button>
      <span className="flex items-center gap-1">
        <div>Page</div>
        <strong>
          {table.getState().pagination.pageIndex + 1} of {table.getPageCount()}
        </strong>
      </span>
      <span className="flex items-center gap-1">
        | Go to page:
        <input
          type="number"
          defaultValue={table.getState().pagination.pageIndex + 1}
          onChange={(e) => {
            const page = e.target.value ? Number(e.target.value) - 1 : 0;
            table.setPageIndex(page);
          }}
          className="border p-1 rounded w-16"
        />
      </span> */}
    </Paper>
  );
  //   <div>{table.getRowModel().rows.length} Rows</div>
};
